// Default React, useState and Material Components
import React, { useState } from "react";
import { Box, Breadcrumbs, Button, CircularProgress, Grid, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import { Link } from 'react-router-dom';
// Importing Custom Services
import ApiService from "../../../Services/ApiService";
import ErroHandling from "../../../Services/ErrorHandling";
import GetMenuService from "../../../Services/GetMenuService";

// Importing Custom Components
import SideDrawer from "../../../UIComponent/Drawer";
import DataTable from "../../../UIComponent/DataTable";
import BaseLayout from "../../../UIComponent/BaseLayout";
import AlertDialog from "../../../UIComponent/AlertDialog";
import { toasterSuccess, toasterError } from '../../../UIComponent/Toaster/index';

// Importing Add & Edit Components
import AddEditFrequency from "./AddEditFrequency";

// Import Fluent UI Icons
import { AddIcon, ChevronRightSmallIcon, ClearIcon, SearchIcon } from "@fluentui/react-icons-mdl2";

// Importing useStyles
import useStyles from "../ManageData.styles";

const Status = (props) => {

  // Declaration of States and Component Variables Start Here
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [reload, setReload] = useState(false);
  const [formData, setFormData] = useState([]);
  const [selected, SetSelected] = useState([]);
  const [allStatus, setAllStatus] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openDelete, setOpenDelete] = useState(false);
  const [state, setState] = useState({ right: false });
  const [startSearch, setStartSearch] = useState(false);
  const [isAllSelected, setIsSelected] = useState(false);
  const [crudState, setCrudState] = React.useState(false);
  const [deleteBtnLoadinng, setDeleteBtnLoadinng] = useState(false);
  const [deleteFrequencyData, setDeleteFrequencyData] = useState(null);
  const [sorting, setSorting] = useState({ sortBy: "", isAscending: false });
  const [menuPermission, setMenuPermission] = useState({ allowEdit: true, allowDelete: true, });
  const [access, setAccess] = React.useState({ allowEdit: false, allowDelete: false, allowView: false });

  // Declaration of States and Component Variables End Here

  // Declaration of React Hooks Start Here
  React.useEffect(() => {
    GetMenuService(20, function (err, res) {
      if (res) {
        //console.log(res.data)
        setAccess(res.data)
      } else {
        toasterError(err)
      }
    })
  }, [])
  React.useEffect(() => {
    if (searchValue == "" || searchValue == null || searchValue == undefined) { searchUser('') }
    else { searchUser(searchValue) }
  }, [sorting]);

  React.useEffect(() => {
    if (searchValue == "" || searchValue == null || searchValue == undefined) { searchUser('') }
    else { searchUser(searchValue) }
  }, [page, reload, rowsPerPage])

  const toggleDrawer = (open, mode) => (event, item) => {
    if (mode === "Delete") { setDeleteFrequencyData(item); setOpenDelete(true); }
    else {
      setFormData(item); setState({ ...state, right: open, formData: item }); setCrudState(mode);
    }
  };
  // Declaration of React Hooks End Here

  // Assigning Colums and UI Props
  const columns = [
    { id: "name", label: "Frequency", minWidth: 200, width: "25%", sorting: false },
    { id: "description", label: "Description", minWidth: 400, width: "70%", sorting: false, truncate: 90, tooltipWithTruncate: true }
  ];

// This function handles the keyup event
const handleKeyUp = (event) => {
  // If backspace is pressed and target element is not a button
  if ((event.keyCode === 8 || event.which === 8) && event.target.nodeName !== "BUTTON") {
    // If search value is empty, get frequency data
    if (searchValue.length === 0) { getFrequencyData(); }
  }
  // If enter is pressed and target element is not a button
  if ((event.keyCode === 13 || event.which === 13) && event.target.nodeName !== "BUTTON") {
    // Set total count to 0, page to 0 and start search to true
    setTotalCount(0);
    setPage(0);
    setStartSearch(true)
    // Search user with the value of the target element
    searchUser(event.target.value);
  }
};

// Function to get frequency data from API
const getFrequencyData = () => {
  // Set loading to true
  setLoading(true);
  // If reload is true, set it to false
  if (reload) { setReload(false); }
  // Create an array of parameters for the API call
  let prt = [`pageNumber=${page + 1}`, `pageSize=${rowsPerPage}`];
  // Call the API service
  ApiService.search("managedata/GetFrequencyDetails?", {}, prt)
    .then((res) => {
      // If the response status is 200, set the result and total count
      if (res.status === 200) {
        let result = Array.isArray(res.data) ? res.data : res.data.data || [];
        setAllStatus(result);
        setLoading(false);
        setTotalCount(res.data.totalCount);
      } else { 
          // Else, display an error message
          toasterError(`${res.data}`); 
          setLoading(false); 
      }
    })
    .catch((err) => {
      // Handle any errors
      ErroHandling(err, function (res) {
        toasterError(res)
      })
    });
};

// Function to delete a frequency
const deleteFrequency = () => {
  // Set loading state of delete button to true
  setDeleteBtnLoadinng(true);
  // Store delete frequency data in variable
  let data = deleteFrequencyData;
  // Set active status to false
  data.active = false;
  // Make API call to delete frequency
  ApiService.create(`managedata/DeleteFrequency?frequencyId=${deleteFrequencyData.id}`)
    .then((res) => {
      // If API call is successful, show success message and get updated frequency data
      if (res.status === 200) {
        toasterSuccess("Frequency deleted successfully");
        getFrequencyData();
        setDeleteBtnLoadinng(false);
        setOpenDelete(false);
      } else {
        // If API call fails, show error message
        toasterError("Somthing went wrong");
        setOpenDelete(false);
        setDeleteBtnLoadinng(false);
      }
    })
    .catch((err) => {
      // Handle errors
      ErroHandling(err, function (res) {
        toasterError(res)
      })
      setDeleteBtnLoadinng(false);
    });
};

  // Function for Global Search
  const globalSearch = (value) => { setSearchValue(value); };

// This function is used to search for a user based on the filter value provided
const searchUser = (filterValue) => {
  // Set loading to true while the search is in progress
  setLoading(true);
  // Create an array of parameters to be passed to the API call
  let prt = [`pageNumber=${page + 1}`, `pageSize=${rowsPerPage}`];
  // Make an API call to search for the user
  ApiService.search("managedata/GetFrequencyDetails?",
    { searchText: filterValue }, prt
  )
    .then((res) => {
      // If the response status is 200, set the search result and total count
      if (res.status === 200) {
        let searchResult = Array.isArray(res.data) ? res.data : res.data.data || [];
        setAllStatus(searchResult);
        setLoading(false);
        setTotalCount(res.data.totalCount);
      } else { 
          // If the response status is not 200, display an error message
          toasterError(`${res.data}`); setLoading(false); 
      }
    })
    .catch((err) => {
      // Handle any errors that occur during the API call
      setLoading(false); {
        ErroHandling(err, function (res) {
          toasterError(res)
        })
      }
    });
};

  return (
    // Page Layout Start Here
    <Box>
      <Grid container maxWidth justifyContent="right" alignItems="center">

        {/* Breadcrumbs Menu Start Here */}
        <Grid item xs={12} sm={12} md={6} className="page-title">
          <h2>Frequency</h2>
          <Breadcrumbs
            separator={<ChevronRightSmallIcon className={classes.breadCrumbsIcon} />} aria-label="breadcrumb" className="custom-breadcrumb">
            <Link underline="hover" color="inherit" to={{ pathname: "/app/ownership-changes/source-management" }}>Home</Link>
            <Link underline="hover" color="inherit" to={{ pathname: "/app/commodity" }}>Manage Data</Link>
            <Typography color="text.primary">Frequency</Typography>
          </Breadcrumbs>
        </Grid>
        {/* Breadcrumbs Menu End Here */}

        {/* Main Buttons Start Here */}
        <Grid item xs={12} sm={12} md={6}>
          <Grid container spacing={2} justifyContent="flex-end" alignItems="center">
            <Grid item xs={"auto"}>
              {(access.allowEdit) ? <>
                <Button onClick={toggleDrawer(true, "Add")} variant="contained" color="accent2" startIcon={<AddIcon style={{ fontSize: 16 }} />}>
                  Add Frequency
                </Button>
              </> : null}
            </Grid>
          </Grid>
        </Grid>
        {/* Main Buttons End Here */}

        {/* Baselayout Start Here */}
        <Grid item xs={12}>
          <BaseLayout>
            <Box className={classes.addBorder}>
              {/* Search Option and Total Count Start Here */}
              <Grid item xs={12} className={classes.tableTopPart}>
                <Grid container alignItems="center" justifyContent="left" spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="input-with-icon-textfield"
                      // label="TextField"
                      className={classes.searchByKeyword}
                      value={searchValue}
                      placeholder="Search by Keyword"
                      onKeyUp={handleKeyUp}
                      onChange={(e) => globalSearch(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon className={classes.searchIcon} />
                          </InputAdornment>
                        ),
                      }}
                      variant="standard"
                    />
                    {searchValue ? (
                      <IconButton
                        aria-label="Add"
                        className="serchByClear"
                        // style={{ position: "absolute", top: "5px", right: "0px" }}
                        onClick={() => {
                          setSearchValue("");
                          getFrequencyData();
                        }}
                      >
                        <ClearIcon style={{ fontSize: 10 }} />
                      </IconButton>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} textAlign="right">
                    <Typography variant="subtitle2">
                      Total Records: <span className={classes.totalRecord}>{totalCount}</span>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              {/* Search Option and Total Count End Here */}

              {/* Financial Year Quarters Table /> */}
              <Grid item xs={12}>
                <DataTable
                  className={classes.removeBorder}
                  loading={isLoading}
                  rows={allStatus ? allStatus : []}
                  columns={columns}
                  page={page}
                  setPage={(data) => {
                    setPage(data);
                    setReload(true);
                  }}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={(data) => {
                    setRowsPerPage(data);
                    setReload(true);
                  }}
                  totalCount={totalCount}
                  isAllSelected={isAllSelected}
                  setIsSelected={setIsSelected}
                  selected={selected}
                  setSelected={SetSelected}
                  sorting={sorting}
                  setSorting={(e) => {
                    setReload(true)
                    setSorting(e)
                  }}
                  isActionButton={{
                    ...(access.allowEdit && {
                      edit: toggleDrawer(true, "Edit"),
                    }),
                    ...(access.allowDelete && {
                      delete: toggleDrawer(true, "Delete"),
                    }),
                  }}
                />
              </Grid>
            </Box>
          </BaseLayout>
        </Grid>
      </Grid>

      {/* Add & Edit Frequency Year Quarters Side Drawer */}
      <SideDrawer
        formComp={
          // Calling the AddEditFrequency
          <AddEditFrequency
            state={state}
            setState={setState}
            crudState={crudState}
            formData={formData}
            setFormData={setFormData}
            hideSideDrawer={() => {
              setState({ right: false });
              getFrequencyData();
            }}
          />
        }
        state={state}
        setState={setState}
      />

      {/* Alert Dialog - Confirmation for Delete */}
      {openDelete ? (
        <AlertDialog
          open={openDelete}
          title={"Confirmation"}
          maxWidth={"sm"}
          description={`Are you sure you want to delete the frequency "${deleteFrequencyData?.name}" ?`}
          action={
            <Grid container alignItems="center" justifyContent="right" spacing={2} className={classes.alertDialogButton}>
              <Grid item xs={"auto"}>
                <Button onClick={() => setOpenDelete(false)}>No</Button>
              </Grid>
              <Grid item xs={"auto"}>
                <Button onClick={() => deleteFrequency()} color="secondary">
                  {deleteBtnLoadinng ? (<CircularProgress size={25} />) : ("Yes")}
                </Button>
              </Grid>
            </Grid>
          }
        />
      ) : null}
    </Box>
  );
};

export default Status;